import View from './FormUserUnblocked';
import enhancer from './FormUserUnblocked.enhancer';

export default enhancer(View);
